module.exports = __webpack_public_path__ + "img/2192281-54-0.5deac749.png";